<template>
  <div>
    <!--内容部分 start-->
    <div class="container-page">
      <!-- 上面部分 -->
      <div class="container-top">
        <!-- 标题 -->
        <div class="container-top-title">你好，{{ form.bse_lice_nm }}</div>
        <!-- 交易金额 -->
        <div class="container-top-money">
          <div class="container-top-money-title">交易金额</div>
          <div class="container-top-money-cell">
            <div :class="time == 1 ? 'active' : ''" class="container-top-money-item" @click="timeHandel(1)">今日</div>
            <div :class="time == 2 ? 'active' : ''" class="container-top-money-item" @click="timeHandel(2)">本月</div>
            <div :class="time == 3 ? 'active' : ''" class="container-top-money-item" @click="timeHandel(3)">所有</div>
          </div>
        </div>
        <!-- 金额 -->
        <div v-if="time == 1" class="container-top-money-num">￥ {{ formatAmount(come.today_fee) }}</div>
        <div v-if="time == 2" class="container-top-money-num">￥ {{ formatAmount(come.month_fee) }}</div>
        <div v-if="time == 3" class="container-top-money-num">￥ {{ formatAmount(come.total_fee) }}</div>
        <!-- 数据 -->
        <div class="container-top-money-data">
          <div class="container-top-money-data-item">
            <div>微信(今)</div>
            <div class="income">{{ come.wxpay_summary }}</div>
          </div>
          <div class="container-top-money-data-item">
            <div>支付宝(今)</div>
            <div class="income">{{ come.alipay_summary }}</div>
          </div>
          <div class="container-top-money-data-item">
            <div>云闪付(今)</div>
            <div class="income">{{ come.unionpay_summary }}</div>
          </div>
        </div>
      </div>
      <!-- 菜单 -->
      <div class="menu-data" style="margin-top: 1.3rem">
        <div class="menu-item" v-for="(item, index) in menu_data" :key="index" @click="menu_info(item)">
          <div>
            <img class="menu-item-img" :src="item.menu_img" alt="" />
          </div>
          <div class="menu-item-text">{{ item.menu_text }}</div>
        </div>
      </div>
    </div>
    <!--内容部分 end-->

  </div>
</template>

<script>
// 菜单图片
import merchant_information from '../../assets/images/merchant_information.png' // 商户信息
import transaction_flow from '../../assets/images/transaction_flow.png' // 交易流水
import Summary from '../../assets/images/express_collection.png' // 交易汇总
// import collection_code from '../../assets/images/collection_code.png'; //收款码
// import express_collection from '../../assets/images/express_collection.png'; //快速收款
// import express_collection_2 from '../../assets/images/express_collection_2.png'; //快捷收款

export default {
  name: 'MerchantHomepage', // 商户首页
  data() {
    return {
      time: 1, // 默认显示今日
      openCoupon: '',
      // 收入金额
      come: '',
      form: {}, //商户信息
      menu_data: [
        {
          menu_text: '商户信息',
          menu_img: merchant_information,
          menu_url: '/MerchantInformation'
        },
        {
          menu_text: '交易流水',
          menu_img: transaction_flow,
          menu_url: '/TransactionFlow'
        },

        {
          menu_text: '交易汇总',
          menu_img: Summary,
          menu_url: '/Summary'
        },
        {
          menu_text: '卡券发放与核销',
          menu_img: merchant_information,
          menu_url: '/statement_list',
          is_show: true
        },

        {
          menu_text: '卡券消费',
          menu_img: merchant_information,
          menu_url: '/statement_use',
          is_show: true
        },
        {
          menu_text: '会员管理',
          menu_img: merchant_information,
          menu_url: '/member'
        },
        // {
        //   menu_text: '销售记录',
        //   menu_img: transaction_flow,
        //   menu_url: '/ConsumerOrderStatistics'
        // }
      ]
      //    {
      //         'menu_text': "快捷收款",
      //         'menu_img': express_collection_2,
      //         'menu_url': "/QuickPayment"
      //     },
      // {
      //     'menu_text': "",
      //     'menu_img': "",
      //     'menu_url': ""
      // },
      //  {
      //         'menu_text': "我的收款码",
      //         'menu_img': collection_code,
      //         'menu_url': ""
      //     },
      //     {
      //         'menu_text': "快速收款",
      //         'menu_img': express_collection,
      //         'menu_url': ""
      //     },
    }
  },
  // 组件内路由--进入组件时
  beforeRouteEnter(to, from, next) {
    window.document.body.style.backgroundColor = '#f5f5f5'
    next()
  },
  // 组件内路由--离开组件时
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = ''
    next()
  },

  mounted() {
    // 收入金额
    this.income()
    // 商户信息
    this.information()
    this.getOpenCoupon()
  },
  methods: {
    // 格式化金额
    formatAmount(money) {
      // 将输入的金额字符串转换为数字类型
      let number = parseFloat(money.replace(/,/g, ''));
      // 将数字转换为字符串，并格式化为每三位添加一个逗号
      return number.toLocaleString();
    },

    // 金额切换
    timeHandel(val){
      this.time = val
    },

    // 菜单跳转
    menu_info(item) {
      this.$router.push(item.menu_url)
    },

    // 收入金额
    getOpenCoupon() {
      this.openCoupon = window.sessionStorage.getItem('open_coupon') * 1
      // this.openCoupon=2
    },

    // 商户信息
    information() {
      this.$http.get('/wechat/api.merchant_info/get_basic_info', {
        params: {
          merchant_id: window.sessionStorage.getItem('commercialId')
        }
      })
        .then((response) => {
          this.form = response.data.data
        })
    },

    // 金额信息
    income() {
      this.$http
        .get('/wechat/user/homepage', {
          params: {
            merchant_id: window.sessionStorage.getItem('commercialId')
          }
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.come = response.data.data
            } else {
              Notify({ type: 'danger', message: response.data.msg })
            }
        })
    }
  }
}
</script>

<style scoped lang="less">
.active {
  background-color: rgba(18, 118, 221, 0.996078431372549);
}

.container-page {
  width: 100%;
  height: 100%;
}

.container-top {
  width: 100%;
  height: 200px;
  background-color: rgba(20, 134, 251, 1);
  box-sizing: border-box;
  padding: 32px 16px;
}

.container-top-title {
  font-weight: 700;
  font-size: 22px;
  letter-spacing: 2px;
  color: #FFFFFF;
  line-height: 50px;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.container-top-money {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .container-top-money-title {
    font-weight: 700;
    letter-spacing: 2px;
    color: #FFFFFF;
    font-size: 16px;
    line-height: 40px;
  }

  .container-top-money-cell {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 162px;
    height: 24px;
    background-color: rgba(255, 255, 255, 0.3);
    border: none;
    border-radius: 16px;
    font-size: 12px;
    color: #FFFFFF;
    font-weight: 400;
  }

  .container-top-money-item {
    text-align: center;
    width: 54px;
    height: 24px;
    line-height: 24px;
    border-radius: 16px;
  }

}

.container-top-money-num {
  font-weight: 700;
  font-size: 22px;
  letter-spacing: 2px;
  color: #FFFFFF;
  line-height: 40px;
}

.container-top-money-data {
  width: 100%;
  height: 86px;
  box-sizing: border-box;
  padding: 10px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 12px;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.container-top-money-data-item {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.income {
  font-size: 18px;
  font-weight: 700;
}

.menu-data {
  box-sizing: border-box;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  .menu-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 86px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 12px;
    margin-top: 10px;
  }

  .menu-item-img {
    width: 36px;
    height: 36px;
  }

  .menu-item-text {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }

}
</style>
